import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "radio-active",
  "use": "radio-active-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"radio-active\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#003B91\" cx=\"9\" cy=\"9\" r=\"9\" /><circle fill=\"#FFF\" cx=\"9\" cy=\"9\" r=\"4.5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol